import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import intl from 'react-intl-universal';
import Box from '@mui/material/Box';
import ActivitiesListResults from './ActivitiesListResults';
import CheckRefresh from '../CheckRefresh';

class ActivitiesDash extends Component {
 
    render () {  
        return (
        <Fragment>
          <CheckRefresh />
          <Box  sx={{ p: 2, border: '1px dashed grey' }}>
          <h1>{intl.get('AUDITLOG')}</h1>
          <p>{intl.get('DASH_AUDITLOG_DESC')}</p> 
          <hr /> 
              <ActivitiesListResults apitoken={this.props.apitoken}/>
            </Box>
        </Fragment>
        )
    }
} 

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken
  });


export default connect(mapStateToProps)(ActivitiesDash);

